export default {
  methods: {
    getAuthenticityToken() {
      return document.querySelector('input[name="authenticity_token"]') ||
        document.querySelector('meta[name="csrf-token"]').content
    }
  }
}
